export default __webpack_public_path__ + "b1c93fbc87d276fdf189f29a276bfd1a.svg";